import { AuthService } from './../../../shared/services/auth.service';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';
import { ZendeskWidgetService } from './../../services/zendesk-widget.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dgx-zendesk-widget',
  templateUrl: './zendesk-widget.component.html',
  styleUrls: ['./zendesk-widget.component.scss'],
})
export class ZendeskWidgetComponent
  extends SubscriberBaseDirective
  implements OnInit {
  public canViewWidget: boolean;
  public isInitializing: boolean = false;
  public zendeskInitialized: boolean = false;

  private authUser = this.authService.authUser;

  constructor(
    private zendeskWidgetService: ZendeskWidgetService,
    private authService: AuthService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.canViewWidget =
      this.authUser?.defaultOrgInfo?.settings.useZendeskWebWidget &&
      !this.authUser?.isSkillAnalyticsClient &&
      !this.authUser?.isSkillInventoryClient;

    this.zendeskWidgetService.zendeskIsInitialized.subscribe((isLoaded) => {
      this.zendeskInitialized = isLoaded;
      if (this.zendeskInitialized) {
        // HACK: try and give zendesk some time to authenticate prior to opening the widget for the first time.
        setTimeout(() => {
          this.openZendeskWidget(); // go ahead and open the widget, since initializing happened when the user clicked the '?' icon
          this.isInitializing = false;
        }, 3000);
      }
    });
  }

  public openZendeskWidget() {
    if (this.zendeskInitialized) {
      // script has already been loaded, we can open the widget
      this.zendeskWidgetService.openWidget();
    } else {
      this.isInitializing = true;
      // the script has not been loaded to the page, we need to begin the initialization process
      this.zendeskWidgetService
        .getWidgetConfiguration()
        .subscribe((zendeskConfig) => {
          this.zendeskWidgetService.initZendesk(zendeskConfig);
        });
    }
  }
}
